import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function SPIE2025() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>ColorTransferLabV2: A Software Testbed for Multi-Modal Color Transfer, Colorization and Style Transfer</BlockTitle>
          <BlockSubtitle>J. Electron. Imaging 34(5), 051002 (2025), doi: 10.1117/1.JEI.34.5.051002.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>Color manipulation is a significant topic not only in artistic fields, such as film production and photography, but also in research areas like medical imaging and forensics, where it has been extensively studied. One prominent approach in this domain focuses on automatically transferring color statistics from one image to another, a process known as color transfer. Over the past few decades, a substantial number of algorithms has been developed and refined to perform color transfer on various data types, including images, videos, point clouds, and light fields.

            To address the limited accessibility and usability of some existing algorithms, we introduce a new version of ColorTransferLab, a web-based software testbed designed for the straightforward application of a wide range of color transfer, style transfer and colorization algorithms. This platform extends support to textured 3D meshes, volumetric videos, and gaussian splattings, alongside the previously mentioned data types. It also provides access to objective metrics widely used for evaluating the quality of color transfer results over recent decades, complementing visual assessments.

            ColorTransferLabV2 is intended to serve as a valuable tool for researchers and artists in the field of automatic color grading, enabling experimentation with color transfer techniques across multiple media.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="300px 300px 300px 300px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://www.spiedigitallibrary.org/journals/journal-of-electronic-imaging/volume-34/issue-5/051002/ColorTransferLabV2--a-software-testbed-for-multi-modal-color-transfer/10.1117/1.JEI.34.5.051002.short")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://www.spiedigitallibrary.org/journals/journal-of-electronic-imaging/volume-34/issue-5/051002/ColorTransferLabV2--a-software-testbed-for-multi-modal-color-transfer/10.1117/1.JEI.34.5.051002.short")}>arXiv</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://github.com/hpotechius/ColorTransferLab")}>Code</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate('/Projects/Applications/ColorTransferLab')}>Tool</BlockButton>
        </BlockContent>
        {/* <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => navigate('/Projects/Datasets/CTPublication')}>Code</BlockButton>
        </BlockContent> */}
      </Block>



      <Footer/>
    </div>
  );
}

export default SPIE2025;
